const loadTeaser = () => {
    const teasers = document.querySelectorAll('.teaser.general');

    const rearrangeElements = () => {
        teasers.forEach(teaser => {
            const cmpTeaser = teaser.querySelector('.cmp-teaser');
            const content = teaser.querySelector('.cmp-teaser__content');
            if (!cmpTeaser || content) return;
            const callToAction = content.querySelector('.cmp-teaser__action-container');
            const image = teaser.querySelector('.cmp-teaser__image');

            if (window.innerWidth < 760) {
                content.insertBefore(image, callToAction);
            } else {
                cmpTeaser.insertBefore(image, content.nextSibling);
            }
        });
    };

    rearrangeElements();
    window.addEventListener('resize', rearrangeElements);
};

if (document.readyState !== 'loading') {
    loadTeaser();
} else {
    document.addEventListener('DOMContentLoaded', loadTeaser);
}
